import {combineReducers, configureStore, createReducer} from '@reduxjs/toolkit';

const createMockReducer = <T>(initialState: T) =>
    createReducer(initialState, builder => {
        builder.addDefaultCase(state => state);
    });

/**
 * The reducers for Host Redux store reducers mock.
 */
export const reducersHostMock = {
    cart: createMockReducer({
        quoteItems: [],
        totals: {
            total: 0,
        },
    }),
    customer: createMockReducer({
        currency: {
            code: 'USD',
            symbol: '$',
        },
        email: '',
        firstname: '',
        form_key: '',
        id: '',
        is_logged_in: false,
        login_in_status: '',
        sha1: '',
        status: 'PENDING' as const,
    }),
    dataLayer: createMockReducer({
        email: '',
    }),
    location: createMockReducer({
        states: {
            US: [],
        },
    }),
    router: createMockReducer({
        action: '',
        location: {hash: '', pathname: '', search: ''},
    }),
    routerInfo: createMockReducer({
        action: '',
        controller: '',
        module: '',
        page: '',
        status: '',
    }),
    stickyHeader: createMockReducer(false),
    storeInfo: createMockReducer({
        address: '',
        email: '',
        fax: '',
        logo: {
            alt: '',
            src: '',
            video: '',
        },
        phones: {
            cart: '',
            default: '',
            homepage: '',
            uhc: '',
        },
        prescription_email: '',
        social: {},
        working_hours: '8',
    }),
};

/**
 * The mocked store for Host Redux store.
 */
export const hostStoreMock = configureStore({
    reducer: combineReducers(reducersHostMock),
});
